
import React from "react";

const Dashboard = () => {
  return (
    <div className="container">
      This is Dashboard
    </div>
  );
};

export default Dashboard;
